import React from "react";
import { db } from "../../firebase/firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";

export default function ResetMigrationsButton() {
  const reset = async () => {
    if (!window.confirm("Reset all migrations? This is for development only.")) {
      return;
    }

    const snap = await getDocs(collection(db, "migrations"));

    for (const d of snap.docs) {
      await deleteDoc(doc(db, "migrations", d.id));
    }

    alert("Migrations reset.");
  };

  return (
    <button onClick={reset} style={{ background: "red", color: "white" }}>
      Reset Migrations
    </button>
  );
}
